import React, { useState } from "react";
import { Monitor, Smartphone } from "lucide-react";
import ImageUploadField from "@/components/admin/ImageUploadField";
import { imageUrl } from "@/lib/api";
import { isPortraitSource } from "@/lib/bannerRenderer";
import { IMAGE_SLOTS, imageSlotNotes } from "@/lib/companyProfile";

/* Kotak pratinjau = rasio & fit yang SAMA dengan renderer storefront (CpImage), agar admin melihat hasil
   crop desktop/mobile sebelum simpan. */
function CropBox({ src, slot, width, label, icon: Icon, testId }) {
  const [fit, setFit] = useState("cover");
  const url = imageUrl(src);
  return (
    <div className="space-y-1" style={{ width }} data-testid={testId} data-fit={fit}>
      <div className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-[#5C5C5C]"><Icon size={11} /> {label}</div>
      <div className="relative overflow-hidden rounded-lg border border-[#E5E5E5] bg-[#F3F4F6]" style={{ aspectRatio: IMAGE_SLOTS[slot].ratio }}>
        {fit === "contain" ? <img src={url} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover blur-xl scale-110 opacity-70" /> : null}
        <img src={url} alt={`Pratinjau ${label}`} className={`relative h-full w-full ${fit === "contain" ? "object-contain p-1" : "object-cover"}`}
          onLoad={(e) => setFit(isPortraitSource({ naturalWidth: e.target.naturalWidth, naturalHeight: e.target.naturalHeight }) ? "contain" : "cover")} />
      </div>
      <div className="text-[10px] text-[#8A8A8A]">{fit === "contain" ? "Ditampilkan utuh (potret)" : "Dipotong rapi di tengah"}</div>
    </div>
  );
}

/* ImageSlotField — ImageUploadField existing (POST /api/upload, 2 MB) + rekomendasi dimensi per slot +
   pratinjau crop desktop & mobile nyata. Tidak ada sistem media baru. */
export function ImageSlotField({ slot, label, value, onChange, testId }) {
  const spec = IMAGE_SLOTS[slot];
  return (
    <div className="space-y-2" data-testid={`${testId}-slot`}>
      <ImageUploadField label={label} value={value || ""} onChange={onChange} notes={imageSlotNotes(slot)} testId={testId} valueField="url" />
      {value ? (
        <div className="rounded-xl border border-dashed border-[#E5E5E5] bg-[#FAFAFA] p-3">
          <div className="text-[11px] font-semibold text-[#374151] mb-2">Pratinjau tampilan storefront — rasio {spec.ratioLabel} ({spec.width} × {spec.height} px)</div>
          <div className="flex flex-wrap gap-4 items-start">
            <CropBox src={value} slot={slot} width={220} label="Desktop" icon={Monitor} testId={`${testId}-preview-desktop`} />
            <CropBox src={value} slot={slot} width={120} label="Mobile" icon={Smartphone} testId={`${testId}-preview-mobile`} />
          </div>
        </div>
      ) : null}
    </div>
  );
}
